const FilterBuilderView = async () => import('@/views/filterBuilder/FilterBuilderView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    meta: { title: 'Filter Builder' },
    path: '/filter-builder',
    name: 'filter-builder',
    component: FilterBuilderView
  }
]
